module.exports = __webpack_public_path__ + "img/account--avatar.d814cb60.svg";